import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

import ScheduleDescriptionWeekDay from './ScheduleDescriptionWeekDay'
import ScheduleWeekPrintDetail from './ScheduleWeekPrintDetail'

import { formatDate } from '../../utils';

const useStyles = makeStyles((theme) => ({
    cell: {
        fontSize: '11px'
    }
}));

export default function ScheduleWeekPrint(props) {
    const classes = useStyles();
    const { data } = props;

    useEffect(() => {
    }, []);

    return (
        <div id="divRootPrint">
            <TableContainer>
                <Table aria-label="spanning table">
                    <TableBody>
                        {data != null && data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <TableRow>
                                    <TableCell className={classes.cell}>
                                        <ScheduleDescriptionWeekDay date={obj.date} /> - {formatDate(obj.date, 'date')}
                                    </TableCell>
                                </TableRow>
                                {obj.listDetail != null && <TableRow>
                                    <TableCell className={classes.cell}>
                                        <ScheduleWeekPrintDetail data={obj.listDetail} />
                                    </TableCell>
                                </TableRow>}
                            </React.Fragment>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}